import roboTitan from './roboTitan';
import roboDressel from './roboDressel';
import hygienX300 from './hygienX300';
import lumineX300 from './lumineX300';
import shineBotC2 from './shineBotC2';
import escargot from './escargot';

export const PRODUCT_DETAILS = {
  'robo-titan': roboTitan,
  'robo-dressel': roboDressel,
  'hygienx-300': hygienX300,
  'luminex-300': lumineX300,
  'shinebot-c2': shineBotC2,
  'escargot-commercial': escargot,
};
